module.exports = __webpack_public_path__ + "static/media/box-alt.b2cada2c.svg";